export enum PromoCodeType {
	ABSOLUTE = 'absolute',
	RELATIVE = 'relative',
	ABSOLUTE_ARTICLE = 'absolute_article',
	RELATIVE_ARTICLE = 'relative_article',
	GIFT_CARD = 'gift_card',
	DELIVERY_FEE = 'delivery_fee',
	BOGO = 'bogo',
	REWARD = 'reward',
	FREE_ARTICLE = 'free_article',
	VOID = 'void',
	PLUS_ONE = 'plus_one_free',
	SINGLE_RELATIVE_ARTICLE = 'single_relative_article',
	SINGLE_ABSOLUTE_ARTICLE = 'single_absolute_article',
	MULTIPLE_ABSOLUTE_ARTICLE = 'multiple_absolute_article',
	MULTIPLE_RELATIVE_ARTICLE = 'multiple_relative_article'
}
